import { defineStore, acceptHMRUpdate } from 'pinia'

interface PaymentCardState {
  // Selection state shared between `PaymentsTab` and `InfoViewLayout`.
  // Payment details are cached by TanStack Query, not duplicated here.

  selectedPaymentId: string | null
  // Payment id (UUID7) whose card is currently shown in `InfoViewLayout`, or
  // `null` when no payment row is selected.
}

/**
 * Cross-component selection state for the payment info card.
 */
export const usePaymentCardStore = defineStore('paymentCard', {
  state: (): PaymentCardState => ({
    selectedPaymentId: null,
  }),
  getters: {
    /** Convenience flag for `v-if` guards in components that mount the card. */
    hasSelection: (state): boolean => state.selectedPaymentId !== null,
  },
  actions: {
    /**
     * Open the card for the given payment id. Idempotent so re-clicking the
     * selected row does not force the card through a fresh mount cycle.
     */
    selectPayment(id: string): void {
      if (this.selectedPaymentId === id) return
      this.selectedPaymentId = id
    },
    /** Close the card (hides it from `InfoViewLayout`). */
    clearSelection(): void {
      this.selectedPaymentId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePaymentCardStore, import.meta.hot))
}
